import { inject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import {AuthService} from '../../services/authService';

@inject(AuthService, Router)
export class ProfileMenu {
    constructor(authService, router) {

        this.authService = authService;
        this.is_vendasta_user = false;
        this.role=this.authService.getUser().role;
        this.subscription_type=this.authService.getAccount().subscription_type
    if(localStorage.getItem('tp_nav_url') || this.authService.getUser().is_vendasta){
        this.is_vendasta_user = true;
    }

        this.purchaseCredit = true;
        if(this.authService.getAccount().subscription_type && (this.authService.getAccount().subscription_type.startsWith('PLUS') || this.authService.getAccount().subscription_type=='PREMIUM'))
        {
            this.purchaseCredit = false;
        }
    }
    activate() { }

    attached(){
        this.role=this.authService.getUser().role;
        this.subscription_type=this.authService.getAccount().subscription_type;

    }

    detached() { }
    load() { }
}
